export const SMSC_TYPE_FIRST = '1';
export const SMSC_TYPE_SECOND = '2';
